<!-- 市场时讯建议-->
<template>
  <div class="shichangshixunjianyi-layer">
    <div class="scsxjy-container">
      <!-- 左侧市场时讯区域 -->
      <div class="scsxjy-left">
        <!-- 标题栏 -->
        <div class="scsxjy-left-title">
          <div class="title-content">市场时讯</div>
          <!-- 动态装饰点 -->
          <div class="title-dots">
            <div class="dot dot-1"></div>
            <div class="dot dot-2"></div>
            <div class="dot dot-3"></div>
          </div>
        </div>

        <!-- 时讯列表 -->
        <div class="scsxjy-left-content">
          <div class="news-item" v-for="(item, index) in leftContent" :key="index">
            <span class="news-bullet">•</span>
            <span class="news-text">{{ item }}</span>
          </div>
        </div>
      </div>

      <!-- 右侧建议区域 -->
      <div class="scsxjy-right">
        <!-- 实时建议气泡 -->
        <div class="scsxjy-right-message">
          <div class="message-title">实时建议</div>
          <div class="message-content">建议增配大宗商品对冲通胀</div>
        </div>

        <!-- 机器人图像 -->
        <div class="scsxjy-right-image">
          <img src="@/assets/imgs/case/robot.png" alt="AI助手">
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="scsxjy-bottom">
      <button class="build-portfolio-btn" @click="handleClick">构建投资组合</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shichangshixunjianyi',
  components: {},
  props: {},
  data () {
    return {
      leftContent: [
        '【A股政策】科创版做市商制度落地，相关持仓受益',
        '【A股政策】科创版做市商制度落地，相关持仓受益',
        '【A股政策】科创版做市商制度落地，相关持仓受益',
        '【A股政策】科创版做市商制度落地，相关持仓受益',
        '【A股政策】科创版做市商制度落地，相关持仓受益',
        '【A股政策】科创版做市商制度落地，相关持仓受益',
        '【A股政策】科创版做市商制度落地，相关持仓受益',
        '【A股政策】科创版做市商制度落地，相关持仓受益',
        '【A股政策】科创版做市商制度落地，相关持仓受益',
      ]
    }
  },
  computed: {},
  watch: {},
  created () { },
  mounted () { },
  methods: {
    handleClick () {
      this.$emit('next', 'ylcs')
    }
  }
}
</script>

<style scoped lang="less">
.shichangshixunjianyi-layer {
  height: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;

  .scsxjy-container {
    flex: 1;
    width: 100%;
    display: flex;
    gap: 40px;
    margin-bottom: 30px;

    // 左侧市场时讯区域
    .scsxjy-left {
      flex: 1;
      display: flex;
      flex-direction: column;

      // 标题栏
      .scsxjy-left-title {
        position: relative;
        display: flex;
        align-items: center;
        background-image: url('~@/assets/imgs/case/image_310.png');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        width: 260px;
        height: 85px;
        border-radius: 8px;

        .title-content {
          font-size: 20px;
          font-weight: bold;
          color: #fff;
          margin-left: 80px;
        }

        // 动态装饰点
        .title-dots {
          display: flex;
          gap: 8px;
          margin-left: 15px;

          .dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            animation: pulse 2s infinite;

            &.dot-1 {
              background-color: #FFB700;
              animation-delay: 0s;
            }

            &.dot-2 {
              background-color: #36CBCB;
              animation-delay: 0.5s;
            }

            &.dot-3 {
              background-color: #FF7D00;
              animation-delay: 1s;
            }
          }
        }
      }

      // 时讯列表容器
      .scsxjy-left-content {
        flex: 1;
        background: rgba(0, 0, 0, 0.3);
        border-radius: 12px;
        padding: 20px;
        backdrop-filter: blur(10px);
        border: 1px solid rgba(21, 73, 243, 0.2);
        overflow-y: auto;

        // 时讯列表项
        .news-item {
          display: flex;
          align-items: flex-start;
          padding: 12px 0;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);

          &:last-child {
            border-bottom: none;
          }

          .news-bullet {
            color: #1549F3;
            margin-right: 10px;
            font-size: 18px;
            line-height: 1.4;
          }

          .news-text {
            flex: 1;
            font-size: 14px;
            color: #b8c4e0;
            line-height: 1.6;
          }
        }

        // 自定义滚动条
        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-track {
          background: rgba(0, 0, 0, 0.2);
          border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
          background: rgba(21, 73, 243, 0.5);
          border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb:hover {
          background: rgba(21, 73, 243, 0.7);
        }
      }
    }

    // 右侧建议区域
    .scsxjy-right {
      // flex: 0 0 400px;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;

      // 实时建议气泡
      .scsxjy-right-message {
        position: relative;
        background: rgba(0, 0, 0, 0.3);
        border: 1px solid rgba(21, 73, 243, 0.3);
        border-radius: 12px;
        padding: 20px;
        margin-bottom: 20px;
        min-width: 280px;
        backdrop-filter: blur(10px);

        // 气泡下方三角形
        &::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-top: 10px solid rgba(21, 73, 243, 0.3);
        }

        .message-title {
          font-size: 18px;
          font-weight: bold;
          color: #4568F7;
          margin-bottom: 10px;
        }

        .message-content {
          font-size: 16px;
          color: #fff;
          line-height: 1.5;
        }
      }

      // 机器人图像
      .scsxjy-right-image {
        width: 384px;
        height: 384px;
        margin-top: 20px;
        position: relative;

        // 机器人发光效果
        &::before {
          content: '';
          position: absolute;
          top: -10px;
          left: -10px;
          right: -10px;
          bottom: -10px;
          background: radial-gradient(circle, rgba(54, 203, 203, 0.3) 0%, transparent 70%);
          border-radius: 50%;
          animation: glow 3s infinite;
        }

        img {
          width: 100%;
          height: 100%;
          display: block;
          z-index: 1;
          position: relative;
        }
      }
    }
  }

  // 底部按钮区域
  .scsxjy-bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: auto;

    .build-portfolio-btn {
      padding: 12px 40px;
      font-size: 16px;
      font-weight: bold;
      background: #1549F3;
      color: #fff;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 4px 12px rgba(21, 73, 243, 0.3);

      &:hover {
        background: #1549F3;
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(21, 73, 243, 0.5);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  // 动画效果
  @keyframes pulse {

    0%,
    100% {
      opacity: 1;
      transform: scale(1);
    }

    50% {
      opacity: 0.7;
      transform: scale(0.9);
    }
  }

  @keyframes glow {

    0%,
    100% {
      opacity: 0.5;
    }

    50% {
      opacity: 0.8;
    }
  }

  // 响应式设计
  @media (max-width: 768px) {
    .scsxjy-container {
      flex-direction: column;
      gap: 20px;

      .scsxjy-right {
        flex: none;
        min-width: auto;
      }
    }
  }
}
</style>
